module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/icon-step-2_17ac9d6f7026b8448f17dbf253c1f43b.png";